import * as React from 'react'
import { useScrollToTop } from '../shared-hooks/useScrollToTop'

type InputTextProps = React.ComponentPropsWithoutRef<'input'>

export const InputText = (props: InputTextProps): JSX.Element => {
  const inputElement = React.useRef<HTMLInputElement>(null)
  useScrollToTop(inputElement)

  return (
    <input
      className='appearance-none rounded-lg p-4 border bg-zinc-200 font-light placeholder-neutral-600'
      type='text'
      ref={inputElement}
      {...props}
    />
  )
}
